#import "./account-context-fragment.graphql"
#import "./contact-context-fragment.graphql"

fragment LeadContext on Lead {
    id
    name
    bccAddress
    number
    territory
    status
    priority
    isHot
    isOverdue
    createdTime
    deletedTime
    confidence
    closedTime
    anticipatedClosedTime
    stageOverdueTime
    assignee {
        id
        name
    }
    creator {
        id
        name
    }
    value {
        formatted
    }
    clonedFrom {
        id
        number
        htmlUrl
    }
    accounts {
        edges {
            node {
                ...AccountContext
            }
        }
    }
    contacts {
        edges {
            node {
                ...ContactContext
            }
        }
    }
    pipelineStages: stages {
        current {
            id
            name
            deletedTime
            avatarUrl
        }
        totalCount
        edges {
            node {
                id
                name
                stageset {
                    name
                }
            }
        }
    }
    stageset {
        id
        name
        isArchived
    }
    tags {
        id
        name
        tagType
        color
    }
    tagMaps(first: 1000) {
        totalCount
        edges {
            creator {
                id
                name
            }
            createdTime
            node {
                id
                name
                tagType
                color
            }
        }
    }
    outcome {
        id
        name
    }
    deletedTime
    sendToDestinations {
        name
        localUrl
    }
    externalResources {
        externalId
        externalService
        externalResourceType
    }
}
